var map = {
	"./img-swiper1.png": "MdQ4",
	"./img-swiper2.png": "y4fM",
	"./img-swiper3.png": "ML5t",
	"./img-swiper4.png": "gYW5",
	"./img-swiper5.png": "0E1x"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "hbwL";


//////////////////
// WEBPACK FOOTER
// ./src/assets/euro ^\.\/img\-swiper.*\.png$
// module id = hbwL
// module chunks = 0